import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { FormInput, FormSelect } from "../forms/elements";
import { scImageType, scLinkType, scStringType } from "../../types";
import moment from "moment";
import FormCheckboxHtmlLabel from "../forms/elements/CheckboxHtmlLabel";
import { Loading } from "../state";
import { apiUtil, getLoyaltyStorage } from "../../util";
import { isEmpty, isEqual } from "lodash";
import axios from "axios";
import { getSessionStorageKey } from "../../util/sessionStorage";
import { loyaltyDuck } from "../../ducks/loyalty";
import { accountDuck } from "../../ducks/account";

var MyAccountTab = function MyAccountTab(props) {
  var handleEditProfileClick = props.handleEditProfileClick,
      handlePasswordReset = props.handlePasswordReset,
      _props$setLoyaltyAcco = props.setLoyaltyAccountData,
      setLoyaltyAccountData = _props$setLoyaltyAcco === void 0 ? function () {} : _props$setLoyaltyAcco,
      _props$postUpsertAcco = props.postUpsertAccountSfmc,
      postUpsertAccountSfmc = _props$postUpsertAcco === void 0 ? function () {} : _props$postUpsertAcco,
      _props$putUpsertAccou = props.putUpsertAccountSfmc,
      putUpsertAccountSfmc = _props$putUpsertAccou === void 0 ? function () {} : _props$putUpsertAccou,
      accountInfo = props.accountInfo;

  var _ref = props.myAccountTabModel || {},
      cancelLabel = _ref.cancelLabel,
      firstNamePlaceholder = _ref.firstNamePlaceholder,
      emailPlaceholder = _ref.emailPlaceholder,
      submitLabel = _ref.submitLabel,
      emailValidationError = _ref.emailValidationError,
      submitError = _ref.submitError,
      firstNameValidationError = _ref.firstNameValidationError,
      lastNamePlaceholder = _ref.lastNamePlaceholder,
      lastNameValidationError = _ref.lastNameValidationError,
      phoneNumberPlaceholder = _ref.phoneNumberPlaceholder,
      phoneNumberValidationError = _ref.phoneNumberValidationError,
      birthdayCopy = _ref.birthdayCopy,
      monthPlaceholder = _ref.monthPlaceholder,
      dayPlaceholder = _ref.dayPlaceholder,
      legalCheckboxCopy = _ref.legalCheckboxCopy;

  var labelCancel = cancelLabel === null || cancelLabel === void 0 ? void 0 : cancelLabel.value;
  var labelFirstName = firstNamePlaceholder === null || firstNamePlaceholder === void 0 ? void 0 : firstNamePlaceholder.value;
  var labelEmail = emailPlaceholder === null || emailPlaceholder === void 0 ? void 0 : emailPlaceholder.value;
  var btnText = submitLabel === null || submitLabel === void 0 ? void 0 : submitLabel.value;
  var errorEmail = emailValidationError === null || emailValidationError === void 0 ? void 0 : emailValidationError.value;
  var errorSubmit = submitError === null || submitError === void 0 ? void 0 : submitError.value;
  var errorFirstName = firstNameValidationError === null || firstNameValidationError === void 0 ? void 0 : firstNameValidationError.value;
  var labelLastName = lastNamePlaceholder === null || lastNamePlaceholder === void 0 ? void 0 : lastNamePlaceholder.value;
  var errorLastName = lastNameValidationError === null || lastNameValidationError === void 0 ? void 0 : lastNameValidationError.value;
  var labelPhoneNumber = phoneNumberPlaceholder === null || phoneNumberPlaceholder === void 0 ? void 0 : phoneNumberPlaceholder.value;
  var errorPhoneNumber = phoneNumberValidationError === null || phoneNumberValidationError === void 0 ? void 0 : phoneNumberValidationError.value;
  var copyBirthday = birthdayCopy === null || birthdayCopy === void 0 ? void 0 : birthdayCopy.value;
  var labelBirthdayMonth = monthPlaceholder === null || monthPlaceholder === void 0 ? void 0 : monthPlaceholder.value;
  var labelBirthdayDay = dayPlaceholder === null || dayPlaceholder === void 0 ? void 0 : dayPlaceholder.value;
  var defaultMonthOption = {
    value: "",
    label: labelBirthdayMonth
  };
  var defaultDayOption = {
    value: "",
    label: labelBirthdayDay
  };

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      apiErrorMessage = _useState2[0],
      setApiErrorMessage = _useState2[1];

  var _useState3 = useState([defaultMonthOption]),
      _useState4 = _slicedToArray(_useState3, 2),
      monthOptions = _useState4[0],
      setMonthOptions = _useState4[1];

  var _useState5 = useState([defaultDayOption]),
      _useState6 = _slicedToArray(_useState5, 2),
      dayOptions = _useState6[0],
      setDayOptions = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      userInitialValues = _useState8[0],
      setUserInitialValues = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      formHasChanged = _useState10[0],
      setFormHasChanged = _useState10[1];

  var _useState11 = useState(apiUtil.API.loyalty.patchMyAccount),
      _useState12 = _slicedToArray(_useState11, 2),
      patchMyAccountUrl = _useState12[0],
      setPatchMyAccountUrl = _useState12[1];

  var loyaltyStorage = getLoyaltyStorage();
  useEffect(function () {
    generateMonths();
    loadUserData();
  }, []);

  var loadUserData = function loadUserData() {
    var _loyaltyStorage$accou, _loyaltyStorage$accou3;

    var birthdayMonth = "";
    var birthdayDay = "";

    if (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Birthdate) {
      var _loyaltyStorage$accou2;

      var birthDate = new Date(loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Birthdate);

      if (birthDate) {
        birthdayMonth = "".concat(birthDate.getMonth() + 1);

        if (birthdayMonth) {
          handleUpdateMonth(birthdayMonth);
          birthdayDay = "".concat(birthDate.getUTCDate());
        }
      }
    }

    setPatchMyAccountUrl(patchMyAccountUrl.replace("{email}", (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.Email) || ""));
    setTimeout(function () {
      var _loyaltyStorage$accou4, _loyaltyStorage$accou5, _loyaltyStorage$accou6, _loyaltyStorage$accou7;

      setUserInitialValues({
        email: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.Email) || "",
        first_name: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou5 = loyaltyStorage.account) === null || _loyaltyStorage$accou5 === void 0 ? void 0 : _loyaltyStorage$accou5.FirstName) || "",
        last_name: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou6 = loyaltyStorage.account) === null || _loyaltyStorage$accou6 === void 0 ? void 0 : _loyaltyStorage$accou6.LastName) || "",
        phone_number: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou7 = loyaltyStorage.account) === null || _loyaltyStorage$accou7 === void 0 ? void 0 : _loyaltyStorage$accou7.HomePhone) || "",
        birthday_month: birthdayMonth,
        birthday_day: birthdayDay
      });
    });
  };

  var generateMonths = function generateMonths() {
    var months = moment.months();
    months = months.map(function (m, i) {
      return {
        value: (i + 1).toString(),
        label: m
      };
    });
    months.unshift(defaultMonthOption);
    setMonthOptions(months);
  };

  var generateDays = function generateDays(month) {
    if (!month) {
      setDayOptions([defaultDayOption]);
    } else {
      var _days = moment("2020-".concat(month), "YYYY-M").daysInMonth();

      var days = [];

      for (var i = 1; i <= _days; i++) {
        if (i === 1) {
          setDayOptions([{
            value: i.toString(),
            label: i.toString()
          }]);
        }

        days.push({
          value: i.toString(),
          label: i.toString()
        });
      }

      setTimeout(function () {
        setDayOptions(days);
      });
    }
  };

  var handleUpdateMonth = function handleUpdateMonth(newMonth) {
    generateDays(newMonth);
  };

  var handleCancelClick = function handleCancelClick(e) {
    e.preventDefault();
    window.location.reload();
  };

  var getToken = function getToken() {
    var _sessionState$aadResp;

    var sessionState = getSessionStorageKey("account");
    var token = sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp = sessionState.aadResponse) === null || _sessionState$aadResp === void 0 ? void 0 : _sessionState$aadResp.jwtIdToken;
    return token;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "my-account-tab"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-account__title"
  }, "Account Details"), userInitialValues ? /*#__PURE__*/React.createElement(Container, {
    className: "my-account-tab__form-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: userInitialValues,
    validateOnMount: false,
    validate: function validate(values) {
      var errors = {};

      if (!values.email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = errorEmail;
      }

      if (!values.first_name) {
        errors.first_name = errorFirstName;
      }

      if (!values.last_name) {
        errors.last_name = errorLastName;
      }

      if (!values.phone_number || values.phone_number.replace(/\D/g, "").length !== 10) {
        errors.phone_number = errorPhoneNumber;
      }

      if (isEmpty(errors)) {
        var initialValues = _objectSpread(_objectSpread({}, userInitialValues), {}, {
          phone_number: ((userInitialValues === null || userInitialValues === void 0 ? void 0 : userInitialValues.phone_number) || "").replace(/\D/g, "")
        });

        var newValues = _objectSpread(_objectSpread({}, values), {}, {
          phone_number: ((values === null || values === void 0 ? void 0 : values.phone_number) || "").replace(/\D/g, "")
        });

        setFormHasChanged(!isEqual(initialValues, newValues));
      }

      return errors;
    },
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;
      setApiErrorMessage(null);
      var accountInfo = {
        firstName: values.first_name,
        lastName: values.last_name,
        mobilePhone: values.phone_number,
        birthdate: "-"
      };

      if (values.birthday_month && values.birthday_day) {
        var slicedMonth = ("0" + values.birthday_month).slice(-2);
        var slicedDay = ("0" + values.birthday_day).slice(-2);
        accountInfo = _objectSpread(_objectSpread({}, accountInfo), {}, {
          birthdate: "".concat(slicedMonth, "-").concat(slicedDay)
        });
      }

      axios({
        method: "patch",
        headers: _objectSpread(_objectSpread({}, apiUtil.setHeaders()), {}, {
          Authorization: "Bearer ".concat(getToken())
        }),
        data: accountInfo,
        url: patchMyAccountUrl
      }).then(function (res) {
        var _ref3 = res.data || {},
            success = _ref3.success;

        if (success === true) {
          var _loyaltyStorage$accou8, _loyaltyStorage$accou9, _loyaltyStorage$accou10;

          var birthDate = null;

          if (values.birthday_month && values.birthday_day) {
            birthDate = new Date("2020-06-06 14:00:00");
            birthDate.setMonth(values.birthday_month - 1, values.birthday_day);
          }

          var newLoyaltyStorage = _objectSpread(_objectSpread({}, (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : loyaltyStorage.account) || {}), {}, {
            FirstName: accountInfo.firstName,
            LastName: accountInfo.lastName,
            HomePhone: accountInfo.mobilePhone,
            Unsubscribed: (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou8 = loyaltyStorage.account) === null || _loyaltyStorage$accou8 === void 0 ? void 0 : _loyaltyStorage$accou8.Unsubscribed) ? true : false,
            Birthdate: ""
          });

          if (birthDate) {
            newLoyaltyStorage = _objectSpread(_objectSpread({}, newLoyaltyStorage), {}, {
              Birthdate: birthDate
            });
          }

          setLoyaltyAccountData(newLoyaltyStorage);

          var sfmcAccountInfo = _objectSpread(_objectSpread({}, accountInfo), {}, {
            loyaltyCustomerID: loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou9 = loyaltyStorage.account) === null || _loyaltyStorage$accou9 === void 0 ? void 0 : _loyaltyStorage$accou9.ExternalCustomerId,
            loyaltyAccountStatus: loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou10 = loyaltyStorage.account) === null || _loyaltyStorage$accou10 === void 0 ? void 0 : _loyaltyStorage$accou10.Status,
            email: values.email
          });

          putUpsertAccountSfmc(sfmcAccountInfo).then(function () {}).catch(function (err) {
            console.error("putUpsertAccountSfmc Error:", err === null || err === void 0 ? void 0 : err.message);
          }).finally(function () {
            setTimeout(function () {
              window.location.reload();
            });
          });
        } else {
          setApiErrorMessage(errorSubmit);
          setSubmitting(false);
        }
      }).catch(function (err) {
        setApiErrorMessage(err === null || err === void 0 ? void 0 : err.message);
        setSubmitting(false);
      });
    }
  }, function (_ref4) {
    var _accountInfo$account, _accountInfo$account$;

    var isSubmitting = _ref4.isSubmitting,
        isValid = _ref4.isValid,
        setFieldValue = _ref4.setFieldValue,
        validateForm = _ref4.validateForm;
    return /*#__PURE__*/React.createElement(Form, {
      className: "my-account-tab__form"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
      type: "email",
      name: "email",
      className: "cb-form__input--full",
      label: labelEmail,
      value: userInitialValues.email,
      disabled: true,
      component: FormInput
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
      type: "text",
      name: "first_name",
      className: "cb-form__input--full",
      label: labelFirstName,
      value: userInitialValues.first_name,
      component: FormInput
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
      type: "text",
      name: "last_name",
      className: "cb-form__input--full",
      label: labelLastName,
      value: userInitialValues.last_name,
      component: FormInput
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
      type: "tel",
      name: "phone_number",
      className: "cb-form__input--full",
      label: labelPhoneNumber,
      value: userInitialValues.phone_number,
      component: FormInput
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: "12"
    }, /*#__PURE__*/React.createElement("span", {
      className: "my-account-tab__form-bd-copy"
    }, copyBirthday)), /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      className: "my-account-tab__form-col-month"
    }, /*#__PURE__*/React.createElement(Field, {
      type: "select",
      name: "birthday_month",
      label: labelBirthdayMonth,
      options: monthOptions,
      value: userInitialValues.birthday_month,
      component: FormSelect,
      changeHandler: function changeHandler(e) {
        setFieldValue("birthday_day", e.target.value ? "1" : "");
        handleUpdateMonth(e.target.value);
      }
    })), /*#__PURE__*/React.createElement(Col, {
      xs: "6",
      className: "my-account-tab__form-col-day"
    }, /*#__PURE__*/React.createElement(Field, {
      type: "select",
      name: "birthday_day",
      label: labelBirthdayDay,
      value: userInitialValues.birthday_day,
      options: dayOptions,
      component: FormSelect
    }))), apiErrorMessage ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: "12"
    }, /*#__PURE__*/React.createElement("span", {
      className: "my-account-tab__form-error"
    }, apiErrorMessage))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      disabled: isSubmitting || !isValid || !formHasChanged,
      className: "cb-button-primary my-account-tab__form-submit"
    }, btnText))), !isSubmitting && formHasChanged ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
      type: "button",
      className: "cb-button-secondary my-account-tab__form-cancel",
      onClick: handleCancelClick
    }, labelCancel))) : null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: "my-account-tab__form-center"
    }, /*#__PURE__*/React.createElement("a", {
      className: "my-account-tab__form-change",
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        handlePasswordReset();
      }
    }, "Change Password"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      className: "my-account-tab__form-center"
    }, /*#__PURE__*/React.createElement("a", {
      className: "my-account-tab__form-change",
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        handleEditProfileClick();
      }
    }, (accountInfo === null || accountInfo === void 0 ? void 0 : (_accountInfo$account = accountInfo.account) === null || _accountInfo$account === void 0 ? void 0 : (_accountInfo$account$ = _accountInfo$account.idTokenClaims) === null || _accountInfo$account$ === void 0 ? void 0 : _accountInfo$account$.extension_mfasetup) == "on" ? "Disable Two-Factor Authentication" : "Enable Two-Factor Authentication"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Loading, {
      isLoading: isSubmitting
    })));
  })))) : null);
};

var mapStateToProps = function mapStateToProps(state) {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setLoyaltyAccountData: function setLoyaltyAccountData(accountInfo) {
      return dispatch(loyaltyDuck.operations.setLoyaltyAccountData(accountInfo));
    },
    postUpsertAccountSfmc: function postUpsertAccountSfmc(accountInfo) {
      return dispatch(accountDuck.operations.postUpsertAccountSfmc(accountInfo));
    },
    putUpsertAccountSfmc: function putUpsertAccountSfmc(accountInfo) {
      return dispatch(accountDuck.operations.putUpsertAccountSfmc(accountInfo));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountTab);